import {
  WEBSOCKET_BROKEN,
  WEBSOCKET_CLOSED,
  WEBSOCKET_CONNECT,
  WEBSOCKET_DISCONNECT,
  WEBSOCKET_MESSAGE,
  WEBSOCKET_OPEN,
  WEBSOCKET_SEND,
} from '@giantmachines/redux-websocket';

import { WEBSOCKET_PREFIX } from 'shared/constants';

export const REDUX_WEBSOCKET_BROKEN = `${WEBSOCKET_PREFIX}::${WEBSOCKET_BROKEN}`;
export const REDUX_WEBSOCKET_OPEN = `${WEBSOCKET_PREFIX}::${WEBSOCKET_OPEN}`;
export const REDUX_WEBSOCKET_CLOSED = `${WEBSOCKET_PREFIX}::${WEBSOCKET_CLOSED}`;
export const REDUX_WEBSOCKET_MESSAGE = `${WEBSOCKET_PREFIX}::${WEBSOCKET_MESSAGE}`;
export const REDUX_WEBSOCKET_CONNECT = `${WEBSOCKET_PREFIX}::${WEBSOCKET_CONNECT}`;
export const REDUX_WEBSOCKET_DISCONNECT = `${WEBSOCKET_PREFIX}::${WEBSOCKET_DISCONNECT}`;
export const REDUX_WEBSOCKET_SEND = `${WEBSOCKET_PREFIX}::${WEBSOCKET_SEND}`;

export const ACTION_TYPE = {
  CLEAR_CONVERSATION: 'CLEAR_CONVERSATION',
  RESET_BOT_TYPING: 'RESET_BOT_TYPING',
  UPDATE_SUMMARY: 'UPDATE_SUMMARY',
  UPDATE_STEP: 'UPDATE_STEP',
  SAVE_ASSET_ALLOCATION: 'SAVE_ASSET_ALLOCATION',
  SAVE_USER_INFO: 'SAVE_USER_INFO',
  GENERATE_CHANNEL: 'GENERATE_CHANNEL',
  PRE_MESSAGE_SEND: 'PRE_MESSAGE_SEND',
  GET_PRODUCTS_OVERVIEW: 'GET_PRODUCTS_OVERVIEW',
  SAVE_FUND_FACTSHEET: 'SAVE_FUND_FACTSHEET',
  GET_SAVED_INVESTOR_PROFILE: 'GET_SAVED_INVESTOR_PROFILE',
  GET_SAVED_RISK_ASSESSMENT: 'GET_SAVED_RISK_ASSESSMENT',
  GET_SAVED_INVESTMENT_PREFERENCE: 'GET_SAVED_INVESTMENT_PREFERENCE',
  SAVE_STEP_STATUS: 'SAVE_STEP_STATUS',
  CLEAR_CONVERSATION_HISTORY: 'CLEAR_CONVERSATION_HISTORY',
  SET_REDO: 'SET_REDO',
  REFRESH_USER: 'REFRESH_USER',
  ACTIVATE_START_STEP: 'ACTIVATE_START_STEP',
  GET_GOAL_SUMMARY_INVESTMENT_GOAL: 'GET_GOAL_SUMMARY_INVESTMENT_GOAL',
  SUBMIT_APPOINTMENT_PENDING: 'SUBMIT_APPOINTMENT_PENDING',
  SUBMIT_APPOINTMENT_SUCCESS: 'SUBMIT_APPOINTMENT_SUCCESS',
  SUBMIT_APPOINTMENT_FAILURE: 'SUBMIT_APPOINTMENT_FAILURE',
  SEND_EMAIL_SUCCESS: 'SEND_EMAIL_SUCCESS',
  ASSET_ALLOC_REF_CODE_SUCCESS: 'ASSET_ALLOC_REF_CODE_SUCCESS',
  ASSET_ALLOC_REF_CODE_FAIL: 'ASSET_ALLOC_REF_CODE_FAIL',
};
